import { render } from "./SceneWizardStep3.vue?vue&type=template&id=76c4d3ca&ts=true"
import script from "./SceneWizardStep3.ts?vue&type=script&lang=ts"
export * from "./SceneWizardStep3.ts?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__